import { Box, Typography } from '@mui/material';

import AssistantAvatar from './assistant-avatar';
import { bounce, bubbleRadius } from './assistant-theme';

interface TypingIndicatorProps {
  label: string;
  /** What the assistant is doing, said next to the dots. */
  status: string;
}

export default function TypingIndicator({
  label,
  status,
}: TypingIndicatorProps) {
  return (
    <Box
      role="status"
      aria-label={label}
      sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}
    >
      <AssistantAvatar />
      <Box
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 1.5,
          py: 1.5,
          borderRadius: bubbleRadius(theme, false),
          bgcolor: 'action.hover',
        })}
      >
        {[0, 1, 2].map((dot) => (
          <Box
            key={dot}
            sx={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              bgcolor: 'text.secondary',
              animation: `${bounce} 1.2s ease-in-out ${dot * 0.15}s infinite`,
            }}
          />
        ))}
        {status && (
          <Typography
            variant="body2"
            sx={{ ml: 0.75, color: 'text.secondary' }}
          >
            {status}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
